<script>
	import {onMount,createEventDispatcher} from "svelte";
	import { Response,SupportUser } from "./store.js";
	import wrappedFetch from "../../wrappedFetch.js";
	export let supportId;
	export let isPageLoading = true;
	let data;
	const dispatch = new createEventDispatcher();
	const getFormContactData = async () => {
		let resp = await wrappedFetch(
			`/support/GetSupportFormData?supportId=${supportId}`,
			{ method: "post" }
		);
		return await resp.json();
	};
	onMount(async()=>{
		if(supportId != null)
	{
		 data = await getFormContactData();
		
	}
	else
	data = $Response;
	isPageLoading = false;
	})
	
</script>
{#if !isPageLoading}
<section class="section">
	<div class="container">
		<div class="columns is-centered is-desktop">
			<div class="column is-10-desktop">
				<div class="step-13-shows" style="word-break:break-word;">
					<div style="display:flex;justify-content:flex-end;"><a
					class="button"
					tabindex="0"
					href="#"
					on:click|preventDefault={() => {
						if (SupportUser != null) 
                                dispatch('pageChange', '/user/home');
                                else 
                                dispatch('pageChange', '/');
					}}>
					
					Home
				</a>
				</div>
					{#if Object.keys(data).length == 0}
					<nav class="panel"  tabindex="0">
						<div class="panel-block">
							<div class="column">
					<h2>Information related to the query was not found.</h2>
							</div>
						</div>
					</nav>
					{:else}				
					<h1 class="title is-3">Query Details</h1>
					<nav class="panel" style="margin-top: 15px;" tabindex="0">
						<div
							class="panel-heading "
							style="display: flex;align-items: stretch;font-size: inherit;">
							<strong>Your Details</strong>
						</div>

						<div class="panel-block">
							<div class="column">
								<div class="field">
									Name:
									<strong> <span>{data.forename} {data.surname}</span> </strong>
								</div>
								{#if data.username && data.username !=""}
								<div class="field">
									Username:
									<strong> <span>{data.username}</span> </strong>
								</div>
								{/if}
								<div class="field">
									Email:
									<strong> <span>{data.email}</span> </strong>
								</div>
								<div class="field">
									Contact number:
									<strong><span>{data.mobile}</span> </strong>
								</div>
								<div class="field">
									Post Code:
									<strong><span>{data.postcode}</span> </strong>
								</div>
								<div class="field">
									Local Authority:
									<strong><span>{data.la}</span> </strong>
								</div>
							</div>
						</div>
					</nav>
					<nav class="panel" style="margin-top: 15px;" tabindex="0">
						<div
							class="panel-heading "
							style="display: flex;align-items: stretch;font-size: inherit;">
							<strong>Issue Details</strong>
						</div>

						<div class="panel-block">
							<div class="column">
								<div class="field">
									Topic:
									<strong> <span>{data.issue}</span> </strong>
								</div>
								<div class="field">
									Child name:
									<strong> <span>{data.childname}</span> </strong>
								</div>
								<div class="field">
									Query:
									<strong><span>{data.reason}</span> </strong>
								</div>
								<div class="field">
									Operating System:
									<strong><span>{data.OS}</span> </strong>
								</div>
								<div class="field">
									Browser:
									<strong><span>{data.Browser}</span> </strong>
								</div>
							</div>
						</div>
					</nav>
					{/if}
				</div>
			</div>
		</div>
	</div>
</section>
{/if}
